import * as api from '../../api';
import { handleError, receiveClasses, receiveUsers } from '../actionHelpers';

export const fetchClassesForActiveUser = () => (dispatch, getState) => {
  const state = getState();
  const id = state.users.activeUser.user.id;
  return dispatch(fetchClassesForUser(id));
};

export const fetchClassesForUser = (userId) => (dispatch, getState) => {
  dispatch({
    type: 'FETCH_USERS_CLASSES_REQUEST',
    userId,
  });
  const token = getState().users.auth.token;
  return api.getClassesForUser(userId, token).then(
    (response) => {
      if (response.errorMsg) {
        handleError(dispatch, response, 'FETCH_USERS_CLASSES_FAILURE');
      } else {
        dispatch(
          receiveClasses(response, 'FETCH_USERS_CLASSES_SUCCESS', { userId })
        );
      }
    },
    (error) => handleError(dispatch, error, 'FETCH_USERS_CLASSES_FAILURE')
  );
};

export const fetchClass = (id) => (dispatch, getState) => {
  dispatch({
    type: 'FETCH_CLASS_REQUEST',
    id,
  });
  const token = getState().users.auth.token;
  return api.getClass(id, token).then(
    (response) => {
      if (response.errorMsg) {
        handleError(dispatch, response, 'FETCH_CLASS_FAILURE');
      } else {
        dispatch(receiveClasses(response, 'FETCH_CLASS_SUCCESS'));
        dispatch(fetchClassDisabledModules(id));
      }
    },
    (error) => handleError(dispatch, error, 'FETCH_CLASS_FAILURE')
  );
};

export const addExistingStudentToClass = (studentId, classId) => (
  dispatch,
  getState
) => {
  dispatch({
    type: 'ADD_EXISTING_STUDENT_TO_CLASS_REQUEST',
    studentId,
    classId,
  });
  const token = getState().users.auth.token;
  return api.addExistingStudentToClass(studentId, classId, token).then(
    (response) => {
      if (response.errorMsg) {
        handleError(
          dispatch,
          response,
          'ADD_EXISTING_STUDENT_TO_CLASS_FAILURE',
          { studentId, classId }
        );
      } else {
        const formName = 'addStudentToClass';
        dispatch({
          type: 'SUBMIT_FORM_SUCCESS',
          formName,
          formId: 'addStudentToClass',
        });
        dispatch(receiveUsers(response, 'ADD_STUDENT_TO_CLASS', { classId }));
      }
    },
    (error) =>
      handleError(dispatch, error, 'ADD_EXISTING_STUDENT_TO_CLASS_FAILURE', {
        studentId,
        classId,
      })
  );
};

export const removeStudentFromClass = (studentId, classId) => (
  dispatch,
  getState
) => {
  dispatch({
    type: 'REMOVE_STUDENT_FROM_CLASS_REQUEST',
    studentId,
    classId,
  });
  const token = getState().users.auth.token;
  return api.removeStudentFromClass(studentId, classId, token).then(
    (response) => {
      if (response.errorMsg) {
        handleError(dispatch, response, 'REMOVE_STUDENT_FROM_CLASS_FAILURE', {
          studentId,
          classId,
        });
      } else {
        dispatch({
          type: 'REMOVE_STUDENT_FROM_CLASS_SUCCESS',
          studentId,
          classId,
        });
      }
    },
    (error) =>
      handleError(dispatch, error, 'REMOVE_STUDENT_FROM_CLASS_FAILURE', {
        studentId,
        classId,
      })
  );
};

export const fetchClassIfNeeded = (id) => (dispatch, getState) => {
  const state = getState();
  if (!state.classes.byId[id]) return dispatch(fetchClass(id));
};

export const fetchClassDisabledModules = (classId) => (dispatch, getState) => {
  dispatch({
    type: 'FETCH_CLASS_DISABLED_MODULES_REQUEST',
    classId,
  });
  const { token } = getState().users.auth;
  return api.getClassDisabledModules(classId, token).then(
    (response) => {
      if (response.errorMsg) {
        handleError(dispatch, response, 'FETCH_CLASS_DISABLED_MODULES_FAILURE');
      } else {
        dispatch({
          type: 'FETCH_CLASS_DISABLED_MODULES_SUCCESS',
          response,
          classId,
        });
      }
    },
    (error) =>
      handleError(dispatch, error, 'FETCH_CLASS_DISABLED_MODULES_FAILURE')
  );
};

export const postClassDisabledModules = (
  schoolId,
  classId,
  disabledModules
) => (dispatch, getState) => {
  dispatch({
    type: 'POST_CLASS_DISABLED_MODULES_REQUEST',
    classId,
  });
  const { token } = getState().users.auth;
  return api
    .postClassDisabledModules(token, { schoolId, classId, disabledModules })
    .then(
      (response) => {
        if (response.errorMsg) {
          handleError(
            dispatch,
            response,
            'POST_CLASS_DISABLED_MODULES_FAILURE'
          );
        } else {
          dispatch(fetchClassDisabledModules(classId));
          dispatch({
            type: 'POST_CLASS_DISABLED_MODULES_SUCCESS',
            response,
            classId,
          });
        }
      },
      (error) =>
        handleError(dispatch, error, 'POST_CLASS_DISABLED_MODULES_FAILURE')
    );
};

export const clearMessages = () => (dispatch) => {
  dispatch({
    type: 'CLEAR_CLASSES_MESSAGES',
  });
};

export const clearNewClassId = () => (dispatch) => {
  dispatch({
    type: 'CLEAR_NEW_CLASS_ID',
  });
};
